export const generateSlugFromName = (name: string): string =>
  name
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')

const generateRandomSuffix = (length = 4): string =>
  Math.random()
    .toString(36)
    .substring(2, 2 + length)

export const generateSlugSuggestions = (baseSlug: string, count = 3): string[] =>
  Array.from({ length: count }, () => `${baseSlug}-${generateRandomSuffix()}`)

export class SlugConflictError extends Error {
  readonly suggestions: string[]

  constructor(slug: string, suggestions: string[]) {
    super(`Slug "${slug}" is already taken`)
    this.name = 'SlugConflictError'
    this.suggestions = suggestions
  }
}

interface ClerkErrorItem {
  code?: string
  message?: string
}

export const getClerkErrors = (error: unknown): ClerkErrorItem[] | null => {
  if (error && typeof error === 'object' && 'errors' in error) {
    return (error as { errors: ClerkErrorItem[] }).errors
  }
  return null
}

export const isClerkSlugConflict = (error: unknown): boolean =>
  getClerkErrors(error)?.[0]?.code === 'form_identifier_exists'
